import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const CardHeader = (props) => {
    const { className, ...otherProps } = props;
    return <div {...otherProps} className={clsx("card-header", className)} />;
};
CardHeader.propTypes = {
    className: PropTypes.string,
};

export default CardHeader;
